import styled from "styled-components/macro";

export const SurveyModalContainer = styled.div`
  width: 575px;
  min-height: 555px;
  max-height: 555px;
  display: flex;
  flex-direction: column;
  background: var(--menu-color);

  border-radius: 20px;

  position: relative;

  .modal-header {
    position: absolute;
    right: 20px;
    top: 20px;
    width: 100%;
    display: flex;
    justify-content: right;
  }

  .content {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
`;

export const NewSurveyPageWrapper = styled.div`
  width: 50%;
  position: absolute;
  left: 50%;
  margin: auto;
  border-radius: 35px;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.15);
  top: 50%;
  transform: translate(-50%, -50%);

  width: 575px;
  min-height: 555px;
  max-height: 555px;
  display: flex;
  flex-direction: column;
  background: var(--menu-color);
  color: var(--grey-0);
  justify-content: center;

  .survey-completed {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
  }

  @media (max-width: 768px) {
    width: 95%;
  }
`;

export const SurveyContainer = styled.div`
  flex: 1;
  padding: 25px 25px 30px 25px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  font-size: 16px;

  @media (max-width: 768px) {
    width: 85%;
    max-height: none;
  }

  h1 {
    font-size: 25px;
    color: var(--grey-0);
    margin-bottom: 3px;
    line-height: 35px;
    margin-left: 0px;
    font-family: "GT Super Text";
    font-weight: 400;
    padding-top: 20px;
  }

  h2 {
    font-size: 16px;
    color: var(--grey-2);
    font-weight: 500;
    line-height: 20px;
    margin-left: 0px;
  }
  .conversation {
    margin-top: 20px;
  }

  .stepper {
    display: flex;
    flex-direction: column;
    flex: 1;

    .header {
      display: flex;
      gap: 8px;
      padding: 10px 0;

      .stepper-step {
        width: 50px;
        height: 4px;
        border-radius: 4px;

        background-color: var(--grey-3);

        &.selected {
          background-color: var(--primary-cta-hover);
        }
      }
    }

    .panel {
      display: flex;
      flex-direction: column;
      flex-grow: 1;
    }
  }

  .step-container {
    display: flex;
    flex-direction: column;
    gap: 10px;
    flex-grow: 1;

    header {
      text-align: left;
      margin-bottom: 20px;
    }

    .main {
      display: flex;
      flex-direction: column;
      flex-grow: 1;

      .spacer {
        display: flex;
        flex-grow: 1;
      }

      .item-list {
        display: flex;
        flex-direction: column;
        gap: 8px;
        overflow-y: auto;

        &.wrapped {
          flex-flow: row wrap;
        }

        .item {
          border: 1px solid var(--grey-3);
          border-radius: 8px;
          padding: 10px 8px;
          color: var(--grey-0);
          display: flex;
          flex-direction: row;
          gap: 6px;
          font-weight: 500;
          font-size: 16px;
          align-items: center;
          cursor: pointer;
          transition: all 0.2s;

          > *:nth-child(2) {
            flex-shrink: 0;
          }

          input {
            display: none;
          }

          label {
            cursor: inherit;
          }

          &:hover {
            border-color: var(--grey-2);

            svg {
              path {
                fill: var(--grey-1);
              }
            }
          }

          &.selected {
            border-color: var(--primary-cta-high-contrast);
            color: var(--primary-cta-high-contrast);

            svg {
              path {
                fill: var(--primary-cta-high-contrast);
              }

              circle {
                stroke: var(--primary-cta-high-contrast);
              }

              circle:last-child {
                fill: var(--primary-cta-high-contrast);
              }
            }
          }

          svg {
            height: 16px;
            width: 16px;
            path {
              fill: var(--grey-2);
            }
          }
        }
      }
    }

    footer {
      display: grid;
      gap: 8px;
      grid-template-columns: 1fr 1fr;
      justify-items: end;

      button {
        border-radius: 10px !important;
        background-color: var(--button-background-color);

        &:only-child {
          grid-column: 1 / -1;
          width: 100%;
        }

        &.skip {
          background-color: var(--grey-3) !important;
          color: var(--grey-0) !important;

          &:before {
            border: none;
          }
        }

        &:disabled {
          cursor: not-allowed !important;
        }
      }
    }
  }
`;
